export default __webpack_public_path__ + "static/media/ic-chevron-down12.f186d686.svg";